import { DISPLAY_TYPE } from './../../types';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FORM_STYLE_CONFIG } from '../../d-form/style.config';

@Component({
	selector: 'app-radio',
	templateUrl: './radio.component.html',
	styleUrls: ['./radio.component.css']
})
export class RadioComponent implements OnInit {
	@Input() formElement: any;
	@Input() formValue?: FormGroup;
	@Input() value: any = {};
	@Input() disabled = false;
	@Input() label: string;
	@Input() required: boolean;
	rowClass: any;
	viewCol = 12;
	radioClass: any;
	labelClass: any;
	inputClass: any = [];
	inputDiv: any;
	inputLabelDiv: string[];
	value1 = 'male';
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	@Output() valueChange = new EventEmitter();
	@Output()
	change = new EventEmitter<{
		name: string;
		value: string;
	}>();
	constructor() { }

	ngOnInit() {
		if (this.formElement) {
			this._formatView();
			this.value = this.formElement.value;
			if (this.value !== 'undefined' && this.value !== undefined) {
				this.onChange(this.value);
			}
		}
		if (this.formValue) {
			this.formValue.valueChanges
				.subscribe(val => {
					this.onFormValueChanged(val);
				});
		}
	}
	private _formatView() {
		this.labelClass = [];
		this.inputClass = [];
		this.inputLabelDiv = ['m-radio'];
		let derivedLabelClass = [];
		const derivedInputClass = [];
		if (this.formElement.align && this.formElement.align === 6) {
			derivedLabelClass.push('col-4');
			this.inputDiv = ['col-8'];
		} else {
			derivedLabelClass.push('col-2');
			this.inputDiv = ['col-10'];
		}
		if (this.formElement.labelDiv) {
			derivedLabelClass = [`col-${this.formElement.labelDiv}`];
		}
		if (this.formElement.inputDiv) {
			this.inputDiv = [`col-md-${this.formElement.inputDiv}`];
		}

		derivedLabelClass.push('col-form-label right-text padding-top-zero');
		if (this.formElement.displayType === DISPLAY_TYPE.INLINE) {
			this.inputLabelDiv.push('radio-padding-right');
			derivedInputClass.push('m-radio-inline');
		} else {
			derivedInputClass.push('m-radio-list');
		}
		this.inputClass = this.inputClass.concat(derivedInputClass);
		this.labelClass = this.labelClass.concat(derivedLabelClass);

	}
	// private _formatView() {
	// 	this.labelClass = [FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.default];
	// 	const labelDiv = this.formElement.labelDiv;
	// 	const inputDiv = this.formElement.inputDiv;
	// 	let derivedLabelClass = [
	// 		FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(labelDiv)
	// 	];
	// 	let derivedInputClass = [
	// 		FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.align(inputDiv)
	// 	];
	// 	if (this.formElement.row) {
	// 		this.rowClass = [
	// 			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.condition.row
	// 		];
	// 		derivedLabelClass.push(
	// 			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.label.condition.row
	// 		);
	// 	} else {
	// 		derivedInputClass = [
	// 			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
	// 		];
	// 		derivedLabelClass = [
	// 			FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.align(12)
	// 		];
	// 	}
	// 	this.inputClass = this.inputClass.concat(derivedInputClass);
	// 	this.labelClass = this.labelClass.concat(derivedLabelClass);
	// }
	onFormValueChanged(val) {
		if (!this.value === val) {
			this.value = val;
			if (this.value) {
				this.value = this.formElement.name;
			}
			this.onChange(this.value);
			this.formValue.markAsPristine();
		}
		if (this.formElement.markAsUntouched) {
			this.formElement.markAsUntouched = false;
			this.formValue.markAsPristine();
			this.formValue.markAsUntouched();
		}
	}
	onBlur() {
		this.makeDirty();
	}
	onChange(selectedValue) {
		this.inputValue = selectedValue;
		this.valueChange.emit(selectedValue);
		this.change.emit({
			name: this.formElement.name,
			value: this.value
		});
		this.makeDirty();
	}
	isDisabled() {
		return (this.disabled || this.formElement.readOnly) ? '' : null;
	}

	set inputValue(value) {
		if (this.formValue) {
			this.formValue.setValue(value);
		}
	}
	makeDirty() {
		if (this.formValue) {
			this.formValue.markAsDirty();
			this.formValue.markAsTouched();
		}
	}
}
